(function () {
	const root = document.querySelector("[data-product-addons]");
	if (!root) {
		console.warn("[product-addons] no [data-product-addons] element found");
		return;
	}

	const sharedOption = root.dataset.sharedOption;
	const noneCheckbox = root.querySelector("[data-addon-none]");
	const addonCheckboxes = Array.from(
		root.querySelectorAll("[data-addon-checkbox]"),
	);

	let isAddingToCart = false; // FIX (Aftab): prevents double-submit race condition
	// ============================================================
	// MANUAL VARIANT INJECTION (workaround for Shopify metafield cache)
	// ============================================================
	let manualVariants = [];
	try {
		const raw = root.dataset.manualVariants;
		if (raw) {
			const decoded = raw
				.replace(/&quot;/g, '"')
				.replace(/&amp;/g, "&")
				.replace(/&lt;/g, "<")
				.replace(/&gt;/g, ">")
				.replace(/&#39;/g, "'");
			manualVariants = JSON.parse(decoded);
			console.log(
				"[product-addons] loaded",
				manualVariants.length,
				"manual variants",
			);
		}
	} catch (e) {
		console.warn("[product-addons] could not parse manual variants", e);
	}

	function injectManualVariants(product) {
		if (!manualVariants.length) return product;
		const existingIds = new Set(product.variants.map((v) => v.id));
		manualVariants.forEach((mv) => {
			if (!existingIds.has(mv.id)) {
				product.variants.push(mv);
			}
		});
		if (Array.isArray(product.options)) {
			product.options.forEach((opt, i) => {
				if (
					opt &&
					typeof opt === "object" &&
					Array.isArray(opt.values)
				) {
					manualVariants.forEach((mv) => {
						const val = mv.options[i];
						if (val && !opt.values.includes(val)) {
							opt.values.push(val);
						}
					});
				}
			});
		}
		return product;
	}

	function norm(s) {
		return String(s == null ? "" : s)
			.trim()
			.toLowerCase()
			.replace(/[\u2018\u2019\u2032]/g, "'")
			.replace(/[\u201C\u201D\u2033]/g, '"');
	}

	function syncNoneState() {
		const anyAddonChecked = addonCheckboxes.some((cb) => cb.checked);
		if (noneCheckbox) {
			noneCheckbox.checked = !anyAddonChecked;
		}
	}

	if (noneCheckbox) {
		noneCheckbox.addEventListener("change", () => {
			if (noneCheckbox.checked) {
				addonCheckboxes.forEach((cb) => {
					cb.checked = false;
					const panel = cb
						.closest("[data-addon]")
						.querySelector("[data-addon-options]");
					if (panel) panel.hidden = true;
				});
			} else {
				if (!addonCheckboxes.some((cb) => cb.checked)) {
					noneCheckbox.checked = true;
				}
			}
		});
	}

	function getMainVariantId() {
		const urlVariant = new URLSearchParams(window.location.search).get(
			"variant",
		);
		if (urlVariant) return urlVariant;
		const candidates = [
			'input[name="id"][type="hidden"]',
			'input[name="id"]:not([type="checkbox"]):not([type="radio"])',
			"[data-variant-id]",
			"[data-product-variant-id]",
		];
		for (const sel of candidates) {
			const el = document.querySelector(sel);
			if (el) {
				const val =
					el.value ||
					el.dataset.variantId ||
					el.dataset.productVariantId;
				if (val) return val;
			}
		}
		return null;
	}

	function getMainSelectedSharedValue() {
		const lower = sharedOption.toLowerCase();
		const radios = document.querySelectorAll('input[type="radio"]:checked');
		for (const r of radios) {
			if (r.closest("[data-product-addons]")) continue;
			const name = (r.name || "").toLowerCase();
			if (name.includes(lower)) return r.value;
		}
		const selects = document.querySelectorAll("select");
		for (const s of selects) {
			if (s.closest("[data-product-addons]")) continue;
			const name = (s.name || "").toLowerCase();
			if (name.includes(lower) && s.value) return s.value;
		}
		const fieldsets = document.querySelectorAll(
			'fieldset, [role="radiogroup"], .product-form__input',
		);
		for (const fs of fieldsets) {
			if (fs.closest("[data-product-addons]")) continue;
			const legend = fs.querySelector("legend, .form__label, label");
			if (legend && legend.textContent.toLowerCase().includes(lower)) {
				const active =
					fs.querySelector('[aria-checked="true"]') ||
					fs.querySelector(
						'.is-selected, .selected, [data-selected="true"]',
					);
				if (active)
					return (active.textContent || active.value || "").trim();
			}
		}
		if (
			window.__currentMainVariant &&
			window.__currentMainVariant.options
		) {
			const v = window.__currentMainVariant;
			const idx = (v.optionNames || []).findIndex(
				(n) => n && n.toLowerCase() === lower,
			);
			if (idx > -1) return v.options[idx];
		}
		return null;
	}

	function findVariant(addonProduct, optionsMap) {
		const wantedNorm = {};
		Object.keys(optionsMap).forEach((k) => {
			wantedNorm[norm(k)] = norm(optionsMap[k]);
		});
		console.log(addonProduct.variants);

		return addonProduct.variants.find((variant) => {
			return addonProduct.options.every((optName, i) => {
				const key = norm(
					typeof optName === "object" ? optName.name : optName,
				);
				const wanted = wantedNorm[key];
				if (wanted === undefined || wanted === "") return true;
				return norm(variant.options[i]) === wanted;
			});
		});
	}

	// function by Aftab
	function formatMoney(cents) {
		if (window.Shopify && Shopify.formatMoney) {
			return Shopify.formatMoney(cents);
		}

		return "$" + (Number(cents || 0) / 100).toFixed(2);
	}

	function scheduleAddToCartTotalUpdate() {
		updateAddToCartTotal();
		setTimeout(updateAddToCartTotal, 50);
		setTimeout(updateAddToCartTotal, 150);
		setTimeout(updateAddToCartTotal, 400);
		setTimeout(updateAddToCartTotal, 800);
	}

	function getMainProduct() {
		const addonEl = root.querySelector("[data-addon]");
		if (!addonEl || !addonEl.dataset.mainProductJson) return null;

		try {
			return JSON.parse(addonEl.dataset.mainProductJson.replace(/&quot;/g, '"'));
		} catch (e) {
			console.warn("[product-addons] could not parse main product json", e);
			return null;
		}
	}

	function getMainVariantPrice() {
		const product = getMainProduct();
		const mainId = String(getMainVariantId() || "");

		if (!product || !mainId) return 0;

		const variant = product.variants.find((v) => String(v.id) === mainId);
		return variant ? Number(variant.price || 0) : 0;
	}

	function getQuantity() {
		const qtyInput = document.querySelector(
			'input[name="quantity"], input.quantity__input, [data-quantity-input]'
		);
		return qtyInput ? Math.max(parseInt(qtyInput.value || "1", 10), 1) : 1;
	}

	function updateAddToCartTotal() {
		const btnPrice = document.querySelector(
			'.add_to_cart_buttons_wrapper .btn-price .price-item'
		);

		if (!btnPrice) return;

		let mainPrice = getMainVariantPrice();

		if (!mainPrice) {
			mainPrice = Number(btnPrice.dataset.mainPriceCents || 0);
		}

		const mainTotal = mainPrice * getQuantity();

		const addonsTotal = Array.from(
			root.querySelectorAll("[data-addon-checkbox]:checked")
		).reduce((sum, cb) => {
			const addonEl = cb.closest("[data-addon]");
			return sum + Number(addonEl.dataset.addonPriceCents || 0);
		}, 0);

		btnPrice.textContent = " - " + formatMoney(mainTotal + addonsTotal);
	}

	// function updateAddon(addonEl) {
	// 	let product = JSON.parse(
	// 		addonEl.dataset.addonJson.replace(/&quot;/g, '"'),
	// 	);
	// 	product = injectManualVariants(product);

	// 	const sharedValue = getMainSelectedSharedValue();
	// 	const optionsMap = {};
	// 	if (sharedValue) optionsMap[sharedOption] = sharedValue;

	// 	addonEl
	// 		.querySelectorAll("[data-addon-option-input]:checked")
	// 		.forEach((input) => {
	// 			const optionWrap = input.closest("[data-option-name]");
	// 			optionsMap[optionWrap.dataset.optionName] = input.value;
	// 		});

	// 	const variant = findVariant(product, optionsMap);

	function updateAddon(addonEl) {
		let product = JSON.parse(
			addonEl.dataset.addonJson.replace(/&quot;/g, '"'),
		);
		product = injectManualVariants(product);

		const sharedValue = getMainSelectedSharedValue();
		const optionsMap = {};
		if (sharedValue) optionsMap[sharedOption] = sharedValue;

		addonEl
			.querySelectorAll("[data-addon-option-input]:checked")
			.forEach((input) => {
				const optionWrap = input.closest("[data-option-name]");
				optionsMap[optionWrap.dataset.optionName] = input.value;
			});

		// FIX (Aftab): addon product ka option naam "Fire Feature Size" hota hai,
		// lekin sharedOption sirf "Size" hai — isliye kabhi match nahi hota tha
		// aur size hamesha JSON array ka pehla variant le leta tha.
		// Ye block dhoondta hai jis bhi option ke naam mein "size" word ho,
		// aur usay force se main product ke currently selected size se sync karta hai.
		if (sharedValue) {
			product.options.forEach((opt) => {
				const optName = typeof opt === "object" ? opt.name : opt;
				if (optName && optName.toLowerCase().includes("size")) {
					optionsMap[optName] = sharedValue;
				}
			});
		}

		const variant = findVariant(product, optionsMap);

		const hidden = addonEl.querySelector("[data-addon-variant-id]");
		const unavailableMsg = addonEl.querySelector(
			"[data-addon-unavailable]",
		);
		const checkbox = addonEl.querySelector("[data-addon-checkbox]");

		// commented and changed by Aftab
		// if (variant && variant.available) {
		// 	hidden.value = variant.id;
		// 	unavailableMsg.hidden = true;
		// 	checkbox.disabled = false;
		// } 
		if (variant && variant.available) {
			hidden.value = variant.id;

			const priceEl = addonEl.querySelector("[data-addon-price]");
			if (priceEl) {
				priceEl.textContent = formatMoney(variant.price);
				addonEl.dataset.addonPriceCents = variant.price;
				scheduleAddToCartTotalUpdate();
			}

			unavailableMsg.hidden = true;
			checkbox.disabled = false;
		}else {
			hidden.value = "";
			unavailableMsg.hidden = false;
			if (checkbox.checked) {
				checkbox.checked = false;
				addonEl.querySelector("[data-addon-options]").hidden = true;
				syncNoneState();
			}
			checkbox.disabled = true;
			addonEl.dataset.addonPriceCents = 0;
			scheduleAddToCartTotalUpdate();
		}
	}

	function updateAllAddons() {
		root.querySelectorAll("[data-addon]").forEach(updateAddon);
		scheduleAddToCartTotalUpdate();
	}

	// Wire up addon checkboxes + option changes
	root.querySelectorAll("[data-addon]").forEach((addonEl) => {
		const checkbox = addonEl.querySelector("[data-addon-checkbox]");
		const options = addonEl.querySelector("[data-addon-options]");

		checkbox.addEventListener("change", () => {
			options.hidden = !checkbox.checked;
			syncNoneState();
			updateAddon(addonEl);
			scheduleAddToCartTotalUpdate();
		});

		addonEl
			.querySelectorAll("[data-addon-option-input]")
			.forEach((input) => {
				input.addEventListener("change", () => {
					updateAddon(addonEl);
					scheduleAddToCartTotalUpdate();
				});
			});
	});

	document.addEventListener("change", (e) => {
		if (e.target.closest("[data-product-addons]")) return;
		const t = e.target;
		if (
			t.matches(
				'input[type="radio"], select, input[name*="option"], input[name="id"]',
			)
		) {
			updateAllAddons();
		}
	});

	document.addEventListener("input", (e) => {
		if (
			e.target.matches(
				'input[name="quantity"], input.quantity__input, [data-quantity-input]'
			)
		) {
			scheduleAddToCartTotalUpdate();
		}
	});

	let lastUrl = window.location.href;
	new MutationObserver(() => {
		if (window.location.href !== lastUrl) {
			lastUrl = window.location.href;
			updateAllAddons();
		}
	}).observe(document.body, { subtree: true, childList: true });

	document.addEventListener("variant:change", (e) => {
		window.__currentMainVariant = e.detail && e.detail.variant;
		updateAllAddons();
	});

	document.addEventListener("product-addons:refresh-total", (e) => {
		window.__currentMainVariant = e.detail && e.detail.variant;
		updateAllAddons();
		scheduleAddToCartTotalUpdate();
	});

	// Intercept Add to Cart click
	document.addEventListener(
		"click",
		async (e) => {
			const btn = e.target.closest(
				'button[name="add"], button[type="submit"][name="add"], [data-add-to-cart], button.add-to-cart, button.product-form__submit',
			);
			if (!btn) return;
			if (!root.isConnected) return;

			const checkedAddons = Array.from(
				root.querySelectorAll("[data-addon-checkbox]:checked"),
			);
			if (checkedAddons.length === 0) return;

			e.preventDefault();
			e.stopImmediatePropagation();

			if (isAddingToCart) {
				console.warn("[product-addons] already processing, ignoring duplicate click");
				return;
			}
			isAddingToCart = true;
			btn.disabled = true;

			const mainId = getMainVariantId();
			if (!mainId) {
				console.warn("[product-addons] could not find main variant id");
				return;
			}

			const qtyInput = document.querySelector(
				'input[name="quantity"], input.quantity__input, [data-quantity-input]',
			);
			const quantity = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;

			// ============================================================
			// CAPTURE LINE ITEM PROPERTIES from the main product form
			// (e.g. Color, Fuel source, etc.)
			// ============================================================
			const productForm =
				btn.closest('form[action*="/cart/add"]') ||
				document.querySelector('form[action*="/cart/add"]');
			const mainProperties = {};
			if (productForm) {
				const formData = new FormData(productForm);
				for (const [key, value] of formData.entries()) {
					const match = key.match(/^properties\[(.+)\]$/);
					if (match && value && String(value).trim() !== "") {
						mainProperties[match[1]] = value;
					}
				}
			}

			const mainItem = { id: mainId, quantity };
			if (Object.keys(mainProperties).length > 0) {
				mainItem.properties = mainProperties;
			}

			const addonItems = checkedAddons
				.map((cb) => {
					const addonEl = cb.closest("[data-addon]");
					const variantId = addonEl.querySelector(
						"[data-addon-variant-id]",
					).value;
					if (!variantId) return null;
					return {
						id: variantId,
						quantity: 1,
						properties: { _linked_to: String(mainId) },
					};
				})
				.filter(Boolean);

			setTimeout(async () => {
				try {
					const res = await fetch("/cart/add.js", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/json",
						},
						body: JSON.stringify({ items: [mainItem, ...addonItems] }),
					});
					if (!res.ok) {
						const err = await res.json().catch(() => ({}));
						throw new Error(
							err.description || "Add to cart failed",
						);
					}

					document.dispatchEvent(new CustomEvent("cart:refresh"));
					document.dispatchEvent(new CustomEvent("cart:updated"));
					document.dispatchEvent(new CustomEvent("cart:build"));
					document.dispatchEvent(new CustomEvent("cart:open"));

					setTimeout(() => {
						if (
							!document.querySelector(
								".cart-drawer.is-open, .drawer--cart.is-active, [data-cart-drawer][open]",
							)
						) {
							window.location.href = "/cart";
						}
					}, 100);
				} catch (err) {
					console.error("[product-addons] cart add failed", err);
					alert("Could not add to cart: " + err.message);
				} finally {
					isAddingToCart = false;
					btn.disabled = false;
				}
			}, 100);
		},
		true,
	);

	updateAllAddons();
	syncNoneState();
	scheduleAddToCartTotalUpdate();
})();
